module.exports = __webpack_public_path__ + "img/des_tuse_3.ea936287.jpg";